const CORES_WITH_VISIT_HISTORY = [
  'nuc ribeirao preto dom',
  'nuc bauru dom',
  'nuc curitiba dom',
  'nuc londrina dom',
  'nuc pe dom',
  'nuc porto alegre dom',
  'nuc salvador dom',
  'nuc se dom',
  'nuc sul ba dom',
];

export const isAuthorizedCore = core => {
  if (!core) return false;
  const normalized = core.toLowerCase().trim();
  return CORES_WITH_VISIT_HISTORY.includes(normalized);
};

// Núcleos novos (todos, exceto o primeiro núcleo legado)
const NEW_CORES_WITH_VISIT_HISTORY = CORES_WITH_VISIT_HISTORY.filter(
  core => core !== 'nuc ribeirao preto dom',
);

export const isNewVisitHistoryCore = core => {
  if (!core) return false;
  const normalized = core.toLowerCase().trim();
  return NEW_CORES_WITH_VISIT_HISTORY.includes(normalized);
};
